import { BookingPageCampaignComponent } from '@app/new-ui-lib/booking-page-campaign/booking-page-campaign.component';

export const DYNAMIC_COMPONENTS = {
  InfiniteScrollComponent: 'InfiniteScrollComponent',
  PropertyCardComponent: 'PropertyCardComponent',
  DesktopPropertyCardComponent: 'DesktopPropertyCardComponent',
  ContactUsCardComponent: 'ContactUsCardComponent',
  ThankYouCardComponent: 'ThankYouCardComponent',
  PendingCardComponent: 'PendingCardComponent',
  CompletedCardComponent: 'CompletedCardComponent',
  FailedCardComponent: 'FailedCardComponent',
  FirstProductCardComponent: 'FirstProductCardComponent',
  DesktopProductCardFirstComponent: 'DesktopProductCardFirstComponent',
  SecondProductCardComponent: 'SecondProductCardComponent',
  ThirdProductCardComponent: 'ThirdProductCardComponent',
  FifthProductCardComponent: 'FifthProductCardComponent',
  DesktopFifthProductCardComponent: 'DesktopFifthProductCardComponent',
  ProductsByCategoryCard: 'ProductsByCategoryCard',
  DesktopProductsByCategoryCard: 'DesktopProductsByCategoryCard',
  DesktopCouponCardComponent: 'DesktopCouponCardComponent',
  LoginBenefitsCardComponent: 'LoginBenefitsCardComponent',
  NgoCardComponent: 'NgoCardComponent',
  PriceBreakupCardComponent: 'PriceBreakupCardComponent',

  ShortPropertyCardComponent: 'ShortPropertyCardComponent',
  ShortPropertyCardComponentV1: 'ShortPropertyCardComponentV1',
  OverlayCardComponent: 'OverlayCardComponent',
  StandardCardComponent: 'StandardCardComponent',
  ShortStandardCardComponent: 'ShortStandardCardComponent',
  SecondSmallImageCardComponent: 'SecondSmallImageCardComponent',
  SmallImageCardComponent: 'SmallImageCardComponent',
  DynamicDataCardComponent: 'DynamicDataCardComponent',
  LocationCardComponent: 'LocationCardComponent',
  // UserReviewCardComponent: 'UserReviewCardComponent',
  RowItemComponent: 'RowItemComponent',
  ShortLocationCardComponent: 'ShortLocationCardComponent',
  InformationCardComponent: 'InformationCardComponent',
  SearchFormComponent: 'SearchFormComponent',
  DesktopShortStaySearchFormComponent: 'DesktopShortStaySearchFormComponent',
  ActivityInformationCardComponent: 'ActivityInformationCardComponent',

  ItemListComponent: 'ItemListComponent',
  PopOverRoomGuestPickerComponent: 'PopOverRoomGuestPickerComponent',
  PopOverAutocompleteComponent: 'PopOverAutocompleteComponent',
  PopOverCalendarPickerComponent: 'PopOverCalendarPickerComponent',
  PopOverDateRangePickerComponent: 'PopOverDateRangePickerComponent',
  InfiniteListComponent: 'InfiniteListComponent',

  RadioListComponent: 'RadioListComponent',

  SliderComponent: 'SliderComponent',
  ProductPriceBreakupCardComponent: 'ProductPriceBreakupCardComponent',
  RowLeftRightLayoutComponent: 'RowLeftRightLayoutComponent',
  FooterButtonsComponent: 'FooterButtonsComponent',
  NewCheckboxListComponent: 'NewCheckboxListComponent',
  ChipListComponent: 'ChipListComponent',
  RangeComponent: 'RangeComponent',
  ShortBookingCardComponent: 'ShortBookingCardComponent',
  ErrorCardComponent: 'ErrorCardComponent',
  AskReviewCardComponent: 'AskReviewCardComponent',
  CancelButtonCardComponent: 'CancelButtonCardComponent',
  DownloadVoucherCardComponent: 'DownloadVoucherCardComponent',
  ContactUsFormCardComponent: 'ContactUsFormCardComponent',
  PolicyModalComponent: 'PolicyModalComponent',
  BreadCrumbComponent: 'BreadCrumbComponent',
  HeadingComponent: 'HeadingComponent',
  FilterButtonsComponent: 'FilterButtonsComponent',
  DesktopFilterCardComponent: 'DesktopFilterCardComponent',
  ContainerListShellComponent: 'ContainerListShellComponent',
  ContainerItemListShellComponent: 'ContainerItemListShellComponent',
  MobileDownloadAppComponent: 'MobileDownloadAppComponent',
  DesktopDownloadAppComponent: 'DesktopDownloadAppComponent',
  DesktopBookingProductCardComponent: 'DesktopBookingProductCardComponent',
  DesktopLoginPopoverComponent: 'DesktopLoginPopoverComponent',
  MobileLoginPopoverComponent: 'MobileLoginPopoverComponent',
  MobileDownloadPopoverComponent: 'MobileDownloadPopoverComponent',
  MobileIndianBannerCardComponent: 'MobileIndianBannerCardComponent',
  DesktopIndianBannerCardComponent: 'DesktopIndianBannerCardComponent',
  NewRadioCheckboxListComponent: 'NewRadioCheckboxListComponent',
  LocalityPropertiesNotFoundComponent: 'LocalityPropertiesNotFoundComponent',
  PropertiesNotFoundComponent: 'PropertiesNotFoundComponent',
  DesktopDiscoverIndiaComponent: 'DesktopDiscoverIndiaComponent',
  MobileDiscoverIndiaComponent: 'MobileDiscoverIndiaComponent',
  ImageGalleryComponent: 'ImageGalleryComponent',
  RoomComponent: 'RoomComponent',
  MobileRoomComponent: 'MobileRoomComponent',
  CheckInTimeComponent: 'CheckInTimeComponent',
  CheckInHourComponent: 'CheckInHourComponent',
  StadiumListComponent: 'StadiumListComponent',
  MobileStadiumListComponent: 'MobileStadiumListComponent',
  NewReviewCardComponent: 'NewReviewCardComponent',
  CustomerReviewComponent: 'CustomerReviewComponent',
  MobileLoginCardComponent: 'MobileLoginCardComponent',
  HourPromotionComponent: 'HourPromotionComponent',
  SmallPropertyCardComponent: 'SmallPropertyCardComponent',
  PromoComponent: 'PromoComponent',
  LandmarkComponent: 'LandmarkComponent',
  BookingPageCampaignComponent: 'BookingPageCampaignComponent',
};
